document.addEventListener('DOMContentLoaded', function () {
  initFsbReveal();
  initFsbCarruseles();
  initFsbGaleria();
  initFsbVariantes();
  initFsbMenuHover();
});

function initFsbMenuHover() {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('[data-fsb-dropdown]').forEach(function (menu) {
    var details = menu.querySelector('details');
    var summary = menu.querySelector('summary');
    if (!details || !summary) return;
    var closeTimer;

    menu.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });
    menu.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () { details.removeAttribute('open'); }, 120);
    });

    summary.addEventListener('click', function (e) {
      var url = summary.getAttribute('data-fsb-menu-url');
      if (url) {
        e.preventDefault();
        window.location.href = url;
      }
    });
  });
}

function initFsbReveal() {
  var els = document.querySelectorAll('.fsb-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('fsb-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fsb-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initFsbCarruseles() {
  document.querySelectorAll('[data-fsb-carrusel]').forEach(function (wrap) {
    var track = wrap.querySelector('.fsb-carrusel');
    var prev = wrap.querySelector('[data-fsb-prev]');
    var next = wrap.querySelector('[data-fsb-next]');
    if (!track) return;
    var scrollAmount = function () {
      var card = track.querySelector('.fsb-card');
      return card ? card.getBoundingClientRect().width + 20 : 260;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });
}

function initFsbGaleria() {
  document.querySelectorAll('[data-fsb-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-fsb-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-fsb-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      if (thumb.getAttribute('data-fsb-thumb-variant-id')) return;
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full');
        if (!fullSrc) return;
        main.src = fullSrc;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var verTodas = galeria.querySelector('[data-fsb-ver-todas]');
    var modal = galeria.querySelector('[data-fsb-galeria-modal]');
    if (verTodas && modal) {
      var cerrar = modal.querySelector('[data-fsb-galeria-cerrar]');
      var modalThumbs = modal.querySelectorAll('[data-fsb-modal-thumb]');
      verTodas.addEventListener('click', function () {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      function cerrarModal() {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
      if (cerrar) cerrar.addEventListener('click', cerrarModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) cerrarModal();
      });
      modalThumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var fullSrc = t.getAttribute('data-full');
          if (fullSrc) main.src = fullSrc;
        });
      });
    }
  });
}

function initFsbVariantes() {
  document.querySelectorAll('[data-fsb-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-fsb-variantes-json]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = root.querySelector('[data-fsb-variant-id]');
    var priceEl = root.querySelector('[data-fsb-precio]');
    var compareEl = root.querySelector('[data-fsb-precio-comparado]');
    var submitBtn = root.querySelector('[data-fsb-submit]');
    var badge = root.querySelector('[data-fsb-agotado]');
    var radios = root.querySelectorAll('[data-fsb-opcion]');
    var mainImg = root.querySelector('[data-fsb-galeria-principal]');
    var thumbs = root.querySelectorAll('[data-fsb-thumb]');
    var defaultImg = mainImg ? mainImg.src : null;
    var defaultAlt = mainImg ? mainImg.alt : null;

    function moneda(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      });
    }

    var grupoEls = Array.from(root.querySelectorAll('[data-fsb-opcion-nombre]'));

    function opcionesSeleccionadas() {
      return grupoEls.map(function (grupo) {
        var checked = grupo.querySelector('[data-fsb-opcion]:checked');
        return checked ? checked.value : null;
      });
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var match = variants.find(function (v) {
        return v.options.every(function (val, i) { return val === seleccion[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = moneda(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = moneda(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) submitBtn.disabled = !match.available;
      if (badge) badge.style.display = match.available ? 'none' : '';

      if (mainImg) {
        var targetSrc = match.image || defaultImg;
        mainImg.src = targetSrc;
        mainImg.alt = match.image ? match.alt : defaultAlt;
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-full') === targetSrc);
        });
      }

      radios.forEach(function (r) {
        var testSeleccion = seleccion.slice();
        var grupoIndex = grupoEls.findIndex(function (g) { return g.contains(r); });
        testSeleccion[grupoIndex] = r.value;
        var existe = variants.some(function (v) {
          return v.options.every(function (val, i) { return val === testSeleccion[i]; });
        });
        var label = r.nextElementSibling;
        if (label) label.classList.toggle('is-disabled', !existe);
      });
    }

    radios.forEach(function (r) { r.addEventListener('change', actualizar); });

    thumbs.forEach(function (thumb) {
      var variantId = thumb.getAttribute('data-fsb-thumb-variant-id');
      if (!variantId) return;
      thumb.addEventListener('click', function () {
        var match = variants.find(function (v) { return String(v.id) === String(variantId); });
        if (!match) return;
        grupoEls.forEach(function (grupo, i) {
          var valor = match.options[i];
          var radio = grupo.querySelector('[data-fsb-opcion][value="' + CSS.escape(valor) + '"]');
          if (radio) radio.checked = true;
        });
        actualizar();
      });
    });

    actualizar();
  });
}
